.container {
    width: 100%;
    padding: 16px;
    background-color: var(--static-background-strong);
    border-radius: 8px;
    border: 1px solid var(--static-text-inverse-standard);
    /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
    color: var(--static-text-standard);
  }
  
  .sectionWrapper {
    /* padding: 24px 0; */
  }
  
  .section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .sectionTitle {
    color: var(--static-text-strong);
    font-size: var(--fs-normal);
    font-weight: 500;
    line-height: 24px;
  }
  
  .sectionDescription {
    color: var(--static-text-week);
    font-size: var(--fs-small);
    line-height: 1.25;
  }
  
  .actionButton {
    display: inline-block;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: var(--primary-active);
    font-size: var(--fs-normal);
    font-weight: 600;
    text-decoration: none;
    width: fit-content;
  }
  
  .actionButton:hover {
    text-decoration: underline;
  }
  
  .divider {
    height: 1px;
    background-color: var(--static-divider-standard);
    width: 100%;
    margin: 24px 0;
  }

  .pageContainer {
    padding: 2rem 1rem
  }
